import Vue from "vue";
import App from "./App";
import router from "./router";
import moment from "vue-moment";

import "./assets/css/bootstrap.min.css";
import "./assets/css/font-awesome.min.css";
import "./assets/css/style.css";
import "./assets/css/animate.css";
import "./assets/css/mobile.css";

import "./assets/js/jquery.min.js";
import "./assets/js/bootstrap.min.js";
import "./assets/js/jquery.stellar.min.js";
import "./assets/js/main.js";
import "./assets/css/swiper.min.css";

import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faTrashAlt,
  faPen,
  faCube,
  faGlobe,
  faUser,
  faSignOutAlt,
  faPlusCircle,
  faDonate,
  faPaperclip
} from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(
  faUser,
  faSignOutAlt,
  faGlobe,
  faCube,
  faPen,
  faTrashAlt,
  faPlusCircle,
  faDonate,
  faPaperclip
);

Vue.component("font-awesome-icon", FontAwesomeIcon);
Vue.use(moment);

new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js